import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray-50 px-6 py-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "transport_type",
  class: "block text-sm font-medium text-gray-700"
}, "Transport type", -1)
const _hoisted_3 = ["value", "aria-expanded"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-500",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 9l-7 7-7-7"
    })
  ])
], -1)
const _hoisted_5 = {
  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
  id: "options",
  role: "listbox"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "block truncate" }
const _hoisted_8 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-1.5"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 text-secondary",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "relative",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
        }, [
          _createElementVNode("input", {
            id: "transport_type",
            type: "text",
            readonly: "",
            value: _ctx.selectedValue ? _ctx.selectedValue.display : '',
            onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.transportTypeTouched = true)),
            class: "cursor-pointer block w-full rounded-md bg-white px-3 py-2 text-gray-900 shadow-sm focus:border-secondary focus:ring focus:ring-secondary focus:ring-opacity-50 font-medium",
            role: "combobox",
            "aria-haspopup": "listbox",
            "aria-expanded": _ctx.dropdownOpen.toString(),
            placeholder: "Vælg transporttype"
          }, null, 40, _hoisted_3),
          _hoisted_4,
          _withDirectives(_createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(["relative cursor-default select-none py-2 pl-8 pr-4", { 'text-white bg-secondary': _ctx.selectedValue === option, 'text-gray-900': _ctx.selectedValue !== option }]),
                onClick: _withModifiers(($event: any) => (_ctx.selectValue(option)), ["stop"]),
                role: "option"
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(option.display), 1),
                (_ctx.selectedValue === option)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_6))
            }), 128))
          ], 512), [
            [_vShow, _ctx.dropdownOpen]
          ])
        ]),
        (!_ctx.selectedValue && _ctx.transportTypeTouched)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Vælg venligst en transporttype"))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}